(function () {
  var HEADER_GAP = 20;
  var DESKTOP_MIN = 1241;
  var MIN_VIEWPORT_HEIGHT = 361;
  var header;
  var productWrap;
  var mainWrapper;
  var mobileBtn;
  var desktopFilter;
  var stuck = false;
  var rafId = 0;
  var holdStuck = false;
  var holdStuckTimer = 0;
  var lastFilterMax = -1;
  var lastFilterChrome = -1;
  var FILTER_BOTTOM_GAP = 16;

  var mqlDesktop = window.matchMedia ? window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)') : null;

  function docTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  function isDesktop() {
    return mqlDesktop ? mqlDesktop.matches : window.innerWidth >= DESKTOP_MIN;
  }

  function menuIsOpen() {
    var html = document.documentElement;
    return holdStuck ||
      html.classList.contains('mm-opened') ||
      html.classList.contains('mm-opening') ||
      html.classList.contains('mot-refine-open');
  }

  function setStickyTop() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    document.documentElement.style.setProperty(
      '--collection-sticky-top',
      header.offsetHeight + HEADER_GAP + 'px'
    );
  }

  function filterChromeHeight(sidebar) {
    var menu = sidebar.querySelector('.filter-menu');
    var parent = menu && menu.parentElement;
    if (!parent) return 0;
    var chrome = 0;
    for (var child = parent.firstElementChild; child && child !== menu; child = child.nextElementSibling) {
      var style = window.getComputedStyle(child);
      if (style.display === 'none') continue;
      chrome += child.offsetHeight;
      chrome += parseFloat(style.marginTop) || 0;
      chrome += parseFloat(style.marginBottom) || 0;
    }
    return Math.round(chrome);
  }

  function setFilterMaxHeight() {
    if (!desktopFilter) {
      desktopFilter = document.querySelector('#collection .desktop-refinemenu-hide');
    }
    if (!desktopFilter) return;
    if (!isDesktop() || window.innerHeight < MIN_VIEWPORT_HEIGHT) {
      desktopFilter.style.removeProperty('--mot-filter-sticky-max');
      desktopFilter.style.removeProperty('--mot-filter-chrome-h');
      lastFilterMax = -1;
      lastFilterChrome = -1;
      return;
    }
    var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    var top = desktopFilter.getBoundingClientRect().top;
    var stickyTop = header ? header.offsetHeight + HEADER_GAP : 90;
    var available = Math.floor(Math.min(vh - top, vh - stickyTop) - FILTER_BOTTOM_GAP);
    if (available < 160) available = 160;
    var chrome = filterChromeHeight(desktopFilter);
    if (available === lastFilterMax && chrome === lastFilterChrome) return;
    lastFilterMax = available;
    lastFilterChrome = chrome;
    desktopFilter.style.setProperty('--mot-filter-sticky-max', available + 'px');
    desktopFilter.style.setProperty('--mot-filter-chrome-h', chrome + 'px');
  }

  function shouldStickMobile() {
    if (!mobileBtn || !productWrap || !mainWrapper) return false;
    if (isDesktop() || window.innerHeight < MIN_VIEWPORT_HEIGHT) return false;
    if (menuIsOpen()) return stuck;

    var pin = mobileBtn.parentElement && mobileBtn.parentElement.classList.contains('mot-refine-slot')
      ? mobileBtn.parentElement
      : mobileBtn;
    var scrollY = window.pageYOffset;
    var wrapTop = docTop(productWrap);
    var start = wrapTop - header.offsetHeight - pin.offsetHeight * 0.9 - HEADER_GAP * 2;
    var end = mainWrapper.offsetHeight - wrapTop + start;
    return start <= scrollY && scrollY < end;
  }

  function applyMobile(nextStuck) {
    if (!mobileBtn || nextStuck === stuck) return;
    if (nextStuck) {
      var rect = mobileBtn.getBoundingClientRect();
      mobileBtn.style.left = Math.round(rect.left) + 'px';
      mobileBtn.style.marginLeft = '0px';
    }
    stuck = nextStuck;
    mobileBtn.classList.toggle('is-stuck', stuck);
    mobileBtn.classList.toggle('mm-fixed-top', stuck);
    if (!stuck) {
      mobileBtn.style.left = '';
      mobileBtn.style.marginLeft = '';
      mobileBtn.style.transform = '';
      mobileBtn.style.webkitTransform = '';
    }
  }

  function onScroll() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      applyMobile(shouldStickMobile());
      setFilterMaxHeight();
    });
  }

  function onResize() {
    setStickyTop();
    if (stuck && mobileBtn && !menuIsOpen()) {
      mobileBtn.classList.remove('is-stuck');
      mobileBtn.classList.remove('mm-fixed-top');
      mobileBtn.style.left = '';
      mobileBtn.style.marginLeft = '';
      stuck = false;
    }
    applyMobile(shouldStickMobile());
    setFilterMaxHeight();
  }

  function onMenuClosed() {
    holdStuck = false;
    if (holdStuckTimer) {
      window.clearTimeout(holdStuckTimer);
      holdStuckTimer = 0;
    }
    applyMobile(shouldStickMobile());
  }

  function init() {
    header = document.getElementById('header');
    productWrap = document.getElementById('product-wrap');
    mainWrapper = document.getElementById('mainWrapper');
    mobileBtn = document.querySelector('#collection .refine-Mobile');
    desktopFilter = document.querySelector('#collection .desktop-refinemenu-hide');

    if (!header || !productWrap) return;

    if (mobileBtn && mobileBtn.parentElement && !mobileBtn.parentElement.classList.contains('mot-refine-slot')) {
      var slot = document.createElement('div');
      slot.className = 'mot-refine-slot';
      mobileBtn.parentNode.insertBefore(slot, mobileBtn);
      slot.appendChild(mobileBtn);
    }

    setStickyTop();
    applyMobile(shouldStickMobile());
    setFilterMaxHeight();
    window.requestAnimationFrame(function () {
      lastFilterMax = -1;
      lastFilterChrome = -1;
      setFilterMaxHeight();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onResize, { passive: true });
    }
    if (mqlDesktop) {
      if (mqlDesktop.addEventListener) mqlDesktop.addEventListener('change', onResize);
      else if (mqlDesktop.addListener) mqlDesktop.addListener(onResize);
    }

    if (mobileBtn) {
      mobileBtn.addEventListener('click', function () {
        if (!stuck) return;
        holdStuck = true;
        if (holdStuckTimer) window.clearTimeout(holdStuckTimer);
        holdStuckTimer = window.setTimeout(function () {
          holdStuck = false;
          holdStuckTimer = 0;
        }, 600);
      }, true);
    }

    new MutationObserver(function () {
      if (!menuIsOpen()) onMenuClosed();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        setStickyTop();
        applyMobile(shouldStickMobile());
        setFilterMaxHeight();
      }).observe(header);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
